<template>
  <div id="basic-input-wrapper" ref="basic-input-wrapper">
    <form
      autocomplete="off"
      @submit.prevent="formAction"
      style="width: 100%; height: 100%"
    >
      <label v-if="label" v-html="label"></label>
      <input
        @keyup="$emit('keyup', $event)"
        name="input"
        ref="basic-input"
        v-model="inputText"
        :disabled="disabled"
        :type="inputType"
        :placeholder="placeholder"
        :class="[isValid.value ? 'inputValid' : 'inputInvalid']"
        v-on:input="updateValue($event)"
        :maxlength="maxLength"
      />

      <div
        v-if="this.type === 'password'"
        class="input-icons"
        ref="input-icons"
      >
        <img
          src="/static/icons/closed-eye-icon.svg"
          v-if="!this.showPassword"
          @click="changeInputType"
          style="height: 18px"
        />
        <img
          src="/static/icons/open-eye-icon.svg"
          v-if="this.showPassword"
          @click="changeInputType"
          style="height: 18px"
        />
      </div>
      <transition name="fade">
        <div v-if="!isValid.value && isValid.errorMessage">
          <span class="error-text">{{ $t(isValid.errorMessage) }}</span>
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
export default {
  name: "BasicInput",
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: ""
    },
    type: {
      type: String,
      required: false,
      default: "text"
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    maxLength: {
      type: Number,
      required: false
    },
    fontSize: {
      type: String,
      required: false,
      default: "15px"
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    height: {
      type: String,
      required: false,
      default: "40px"
    },
    isValid: {
      type: Object,
      required: false,
      default: () => {
        return {
          value: true,
          errorMessage: ""
        };
      }
    }
  },
  data() {
    return {
      inputText: this.value,
      showPassword: false,
      inputType: "text"
    };
  },
  mounted() {
    this.inputType = this.type;
    this.$refs["basic-input-wrapper"].style.width = this.width;
    this.$refs["basic-input"].style.height = this.height;
    this.$refs["basic-input"].style["font-size"] = this.fontSize;

    if (this.type === "password") {
      this.$refs["input-icons"].style.top = `${this.$refs["basic-input-wrapper"]
        .clientHeight / 2}px`;
    }
  },
  methods: {
    formAction(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    },
    updateValue() {
      this.$emit("input", this.inputText);
    },
    changeInputType() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    }
  },
  watch: {
    value() {
      this.inputText = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#basic-input-wrapper {
  position: relative;
  label {
    padding-left: 5px;
    font-size: 13px;
    margin: 0;
  }
  input {
    height: 100%;
    width: 100%;
    border-radius: 6px;
    background: #fff;
    padding: 0 12px 0 12px;
    outline: none;
  }
  input[disabled] {
    background: #e6e6e6d1 !important;
    cursor: not-allowed !important;
  }
  .inputValid {
    transition: border 1s;
    border: solid 1px #adadad;
    &:focus {
      transition: box-shadow 1s;
      box-shadow: $input-shadow;
      border: 1px solid $color-primary;
    }
  }
  .inputInvalid {
    transition: border 1s;
    border: 1px solid $color-danger;
    &:focus {
      transition: box-shadow 1s;
      box-shadow: $input-shadow;
      border: 1px solid $color-danger;
    }
  }
  .error-text {
    color: $color-danger;
    font-size: 11px;
    padding-left: 5px;
    font-style: italic;
  }
  .input-icons {
    position: absolute;
    right: 8px;
    cursor: pointer;
  }
}
input::-ms-reveal,
input::-ms-clear {
  display: none;
}
</style>
